const WorkflowIcon = ({ size = 20, color = '#FFFFFF' }) => (
  <svg
    width={size}
    height={size}
    viewBox="0 0 20 20"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 1H3C1.89543 1 1 1.89543 1 3V7C1 8.10457 1.89543 9 3 9H7C8.10457 9 9 8.10457 9 7V3C9 1.89543 8.10457 1 7 1Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M5 9V13C5 13.5304 5.21071 14.0391 5.58579 14.4142C5.96086 14.7893 6.46957 15 7 15H11"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path
      d="M17 11H13C11.8954 11 11 11.8954 11 13V17C11 18.1046 11.8954 19 13 19H17C18.1046 19 19 18.1046 19 17V13C19 11.8954 18.1046 11 17 11Z"
      stroke={color}
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default WorkflowIcon;
